/* global angular */
angular.module('ua5App')
    .factory('FormsFactory', ['$resource', '$rootScope', '$http', function($resource, $rootScope, $http) {
        return {
            rsvp: function(fields) {
                return $http.post($rootScope.apiDevUrl + 'rsvp', fields);
            },
            accomplishments: function(fields) {
                return $http.post($rootScope.apiDevUrl + 'aa', fields);
            },
            contact: function(fields) {
                return $http.post($rootScope.apiDevUrl + 'ac', fields);
            },
            appointment: function(fields) {
                return $http.post($rootScope.apiDevUrl + 'appointment', fields);
            },
            prospective: function(fields) {
                return $http.post($rootScope.apiDevUrl + 'prospective_contact', fields);
            }
        };
    }])
;
